<script>
import Loader from "../widgets/loader.vue";
import moment from "moment";
import DatePicker from "vue2-datepicker";

// Custom Components
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import { socketConnect } from "@/helpers/webSocketHandler";
import iotService from "@/helpers/APIService/iot.service";
import errorHandler from "@/helpers/errorHandler";

export default {
  data() {
    return {
      gatewayConnection: null,
      selectedLock: null,
      webSocketSendData: null,
      webSocketResponse: [],
      isSendCommand: false,
      enable_autolock: false,
      setLockDateTime: moment().format("YYYY-MM-DD HH:mm"),
      showTimePanel: false,
      isAdminOrStaff: "guest_key",
      staff_admin_key: null,
      master_data: "",
      sendCmdtimer: 60,
      timer: null,
      selectedData: null,
    };
  },
  computed: {
    ...authComputed,
    loaderProps() {
      return {
        isLoading: this.isSendCommand,
      };
    },
  },
  components: {
    Loader,
    DatePicker,
  },
  props: {
    currentProps: Object,
  },
  mounted() {
    this.gatewayConnection = this.currentProps.gatewayWebSocketConnection;
    this.selectedLock = this.currentProps.selectedLock;
    this.enable_autolock =
      this.selectedLock.lock_iot_device.last_status.autolock;
    this.getMasterData();
    this.currentProps.selectedLock.lock_iot_device.config_data = {
      ...this.currentProps.selectedLock.lock_iot_device.config_data,
      ...this.currentProps.selectedLock.lock_iot_device.config_data.master_data,
    };
    delete this.currentProps.selectedLock.lock_iot_device.config_data
      .master_data;
    this.selectedData = this.currentProps.selectedLock.lock_iot_device;
  },
  methods: {
    // Method is used to get lock master data
    getMasterData() {
      if (localStorage.master_data) {
        return (this.master_data = JSON.parse(
          localStorage.getItem("master_data")
        ));
      }
      iotService
        .getLockMasterData()
        .then((response) => {
          localStorage.setItem("master_data", JSON.stringify(response));
          this.master_data = response;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to handle door lock related socket
    async doorLockRelatedSocket(command, proccess_for) {
      if (this.gatewayConnection == undefined) return;
      this.watchGatewayConnectionSocket();
      if (this.isSendCommand == false) {
        if (this.gatewayConnection.conn.readyState == 3) {
          Middleware.notification("Please try again !!", "info", 2000);
          return (this.gatewayConnection.conn = socketConnect(
            `iot/iot-gateway/${this.gatewayConnection.id}?token=${this.user.access}`
          ));
        }
        let seq = Math.floor(1234 + Math.random() * 1051);
        let sendData = "";
        this.sendCmdtimer = 60;
        if (proccess_for == "lock") {
          let data = {
            device_id: this.selectedLock.lock_iot_device.id,
            command: command,
            seq: seq,
            params: {},
          };
          if (command == "set_master_data") {
            if (this.selectedLock.lock_iot_device) {
              data.params = {
                macrotech_id: this.master_data.mct_key,
                hotel_id: this.master_data.hotel_key,
                lock_type: "guest_room",
                floor: 1,
                room_number: parseInt(this.selectedLock.room_number),
                autolock: true,
              };
            }
          }
          if (command == "set_admin_key") {
            data.params = {
              key: parseInt(this.master_data.admin_key),
            };
          }
          if (command == "set_staff_key" || command == "set_guest_key") {
            data.params = {
              key: parseInt(this.staff_admin_key),
            };
          }
          if (command == "set_date_time") {
            data.params = {
              date_time: moment(this.setLockDateTime).format(
                "YYYY-MM-DD, hh:mm:ss"
              ),
            };
          }
          this.gatewayConnection.conn.send(JSON.stringify(data));
          sendData = data;
        }
        this.isSendCommand = true;
        this.webSocketSendData = {
          command: command,
          seq: seq,
          Send: sendData.params,
        };
        Middleware.notification(
          "Please wait, we are proccessing your request !!",
          "info",
          2500
        );
      }
    },
    // Method is used to check websocket
    watchGatewayConnectionSocket() {
      this.gatewayConnection.conn.onmessage = (event) => {
        const responseData = JSON.parse(event.data);
        if (responseData.event_type == "device_event") {
          this.enable_autolock = responseData.last_status
            ? responseData.last_status.autolock
            : responseData.config_data.master_data.autolock;
        }
        if (responseData.topic == "CMD") {
          if (responseData.event_type == "replay_event") {
            if (
              responseData.payload.Seq == this.webSocketSendData.seq &&
              responseData.payload.Command == this.webSocketSendData.command
            ) {
              if (
                this.selectedLock.lock_iot_device.id == responseData.iot_device
              ) {
                const response = {
                  ...responseData.cmd_response.Response,
                  ...responseData.cmd_response.Response.master_data,
                };
                delete response.master_data;
                this.webSocketResponse.unshift({
                  Command: this.webSocketSendData.command,
                  send: { ...this.webSocketSendData },
                  response,
                  time: moment().format("HH:mm a"),
                });

                if (responseData.cmd_response) {
                  this.sendCmdtimer = 0;
                  this.countDownTimer;
                }
              }
            }
          }
        }
        if (this.isSendCommand) {
          this.countDownTimer();
        }
      };
    },
    countDownTimer() {
      let interval = setInterval(() => {
        if (this.sendCmdtimer === 0) {
          clearInterval(interval);
          this.isSendCommand = false;
        } else {
          this.sendCmdtimer--;
        }
      }, 1000);
    },
    // Method is used to handle date time change
    handleOpenChange() {
      this.showTimePanel = false;
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    handleToCloseModal(model_name) {
      this.$bvModal.hide(model_name);
    },
    async setKey(key_type) {
      this.$bvModal.show("set-admin-staff-key-modal");
      this.staff_admin_key =
        key_type == "guest_key"
          ? this.selectedLock.lock_iot_device.config_data.guest_key
          : this.selectedLock.lock_iot_device.config_data.staff_key;
      this.isAdminOrStaff = key_type;
    },
  },
};
</script>

<template>
  <div>
    <h5>
      Send Command On Lock ({{
        selectedLock && selectedLock.lock_iot_device
          ? selectedLock.room_number +
            "-" +
            selectedLock.lock_iot_device.device_name
          : ""
      }})
    </h5>
    <hr />
    <div class="row">
      <div class="col-md-4 col-sm-6 mb-2">
        <b-button
          variant="primary"
          class="w-100"
          @click="doorLockRelatedSocket('getstatus', 'lock')"
        >
          Get Lock Status</b-button
        >
      </div>
      <div class="col-md-4 col-sm-6 mb-2">
        <b-button
          variant="primary"
          class="w-100"
          @click="
            doorLockRelatedSocket(
              user.user.iot_app_setting.is_deadbolt_unlock
                ? 'emunlock'
                : 'unlock',
              'lock'
            )
          "
        >
          UnLock Door</b-button
        >
      </div>
      <div class="col-md-4 col-sm-6 mb-2">
        <b-button variant="primary" class="w-100" @click="setKey('guest_key')"
          >Set Guest Key</b-button
        >
      </div>
      <div class="col-md-4 col-sm-6 mb-2">
        <b-button variant="primary" class="w-100" @click="setKey('staff_key')"
          >Set Staff Key</b-button
        >
      </div>
      <div class="col-md-4 col-sm-6 mb-2">
        <b-button
          variant="primary"
          class="w-100"
          @click="doorLockRelatedSocket('set_admin_key', 'lock')"
          >Set Admin Key</b-button
        >
      </div>
      <div class="col-md-4 col-sm-6 mb-2">
        <b-button variant="primary" class="w-100" v-b-modal.set-date-time-modal
          >Set Lock Date-Time</b-button
        >
      </div>
      <div class="col-md-4 col-sm-6 mb-2">
        <b-button
          variant="primary"
          class="w-100"
          @click="doorLockRelatedSocket('set_master_data', 'lock')"
          >Set Master Data</b-button
        >
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="form-check form-switch my-1" slot="is_active">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="enable_autolock"
            @change="
              doorLockRelatedSocket(
                enable_autolock ? 'enable_autolock' : 'disable_autolock',
                'lock'
              )
            "
            id="autolock"
          />
          <label for="autolock">Autolock</label>
        </div>
      </div>
    </div>
    <hr />
    <div class="mt-5">
      <div class="position-relative">
        <Loader :loading="loaderProps"> </Loader>
        <p class="lock-timer mb-0" v-if="isSendCommand">{{ sendCmdtimer }}</p>
      </div>
      <div class="col-md-12" v-if="selectedData">
        <h5 class="font-size-15">
          {{ (selectedData ? selectedData.device_name : "") + "-" }} DEVICE
          CONFIGURATION DATA
        </h5>
        <hr class="my-12" />
        <div class="row">
          <div
            class="col-md-4"
            v-for="(item, key, index) in selectedData.config_data"
            :key="index"
          >
            <h5 class="font-size-14 text-capitalize">
              {{ key }}
            </h5>
            <p class="mb-1 text-dark text-capitalize">
              {{ item }}
            </p>
            <div class="command-lock-border my-12 mb-1" />
          </div>
        </div>
      </div>
      <div v-if="webSocketResponse" class="mt-5">
        <div
          class="row mb-3"
          v-for="(item, index) in webSocketResponse"
          :key="index"
        >
          <h5 class="mb-3">
            <span>{{ webSocketResponse.length - index }}.</span>
            Command :
            <span class="mb-0 text-capitalize text-primary">
              {{ item.Command.replaceAll("_", " ") }} </span
            >({{ item.time }})
          </h5>
          <div class="col-sm-6">
            <h5 class="font-size-15">Send Data</h5>
            <hr class="my-12" />
            <div class="row">
              <template v-if="Object.keys(item.send.Send).length !== 0">
                <div
                  :class="
                    key !== 'master_data' ? 'col-md-4 col-sm-6' : 'd-none'
                  "
                  v-for="(sendI, key, index) in item.send.Send"
                  :key="index"
                >
                  <h5 class="font-size-14 text-capitalize">
                    {{ key }}
                  </h5>
                  <p class="mb-0 text-dark">
                    {{ sendI ? sendI : "-" }}
                  </p>
                  <div class="command-lock-border my-12" />
                </div>
              </template>
              <div v-else class="col-md-4">
                <p class="mb-0 text-dark">No Data Send</p>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <h5 class="font-size-15">Response Data</h5>
            <hr class="my-12" />
            <div class="row">
              <div
                class="col-md-4"
                v-for="(item, key, index) in item.response"
                :key="index"
              >
                <h5 class="font-size-14 text-capitalize">
                  {{ key }}
                </h5>
                <p class="mb-0 text-dark">
                  {{ item ? item : "-" }}
                </p>
                <div class="command-lock-border my-12" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Model is used to display RFID data -->
    <b-modal
      id="set-date-time-modal"
      title="Set Lock Date time"
      centered
      hide-footer
    >
      <div>
        <date-picker
          v-model="setLockDateTime"
          id="set-date-time"
          format="YYYY-MM-DD HH:mm"
          value-type="format"
          type="datetime"
          placeholder="YYYY-MM-DD HH:mm"
          :show-time-panel="showTimePanel"
          :clearable="false"
          @close="handleOpenChange"
        >
          <template v-slot:footer>
            <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
              {{ showTimePanel ? "select date" : "select time" }}
            </button>
          </template></date-picker
        >
        <!--  -->
        <div class="col-md-12 mt-2">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="handleToCloseModal('set-date-time-modal')"
            >Cancel
          </b-button>
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            @click="
              doorLockRelatedSocket('set_date_time', 'lock');
              handleToCloseModal('set-date-time-modal');
            "
          >
            Set
          </b-button>
        </div>
      </div>
    </b-modal>
    <!-- Model is used to set admin and staff key -->
    <b-modal
      id="set-admin-staff-key-modal"
      :title="`Set ${isAdminOrStaff.replaceAll('_', ' ')} Key`"
      centered
      hide-footer
    >
      <div>
        <label for="staff_admin_key"
          >{{ isAdminOrStaff.replaceAll("_", " ") }} Key</label
        >
        <b-form-input
          id="staff_admin_key"
          type="text"
          placeholder="3159"
          v-model="staff_admin_key"
          autocomplete="off"
        ></b-form-input>
        <div class="col-md-12 mt-2">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="handleToCloseModal('set-admin-staff-key-modal')"
            >Cancel
          </b-button>
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            @click="
              doorLockRelatedSocket(
                isAdminOrStaff == 'admin_key'
                  ? 'set_admin_key'
                  : isAdminOrStaff == 'guest_key'
                  ? 'set_guest_key'
                  : 'set_staff_key',
                'lock'
              );
              handleToCloseModal('set-admin-staff-key-modal');
            "
          >
            Set
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style scoped>
.lock-timer {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  color: #000;
}
.command-lock-border {
  border-bottom: 1px dashed #d5d5d5;
}
.my-12 {
  margin: 12px 0px;
}
</style>

<!--
  
       <div class="col-md-4 col-sm-6 mb-2">
        <b-button
          variant="primary"
          class="w-100"
          @click="doorLockRelatedSocket('emunlock', 'lock')"
          >Unlock Door Emergency</b-button
        >
      </div> 
   if (this.isSendCommand) {
          const intervalId = setInterval(() => {
            if (this.sendCmdtimer == 0) {
              this.isSendCommand = false;
              Middleware.notification(
                "We are not able to proccess, try after some time !!",
                "info",
                2500
              );
              this.sendCmdtimer = 60;
              clearInterval(intervalId);
            }
            this.sendCmdtimer--;
          }, 1000);
        } <h5 class="mt-2">Gateway Related Command</h5>
      <hr class="my-12" />
      <div class="col-md-4 mb-2">
        <b-button
          variant="primary"
          class="w-100"
          @click="doorLockRelatedSocket('getstatus', 'gateway')"
          >All Lock Status</b-button
        >
      </div>
      <div class="col-md-4 mb-2">
        <b-button
          variant="primary"
          class="w-100"
          @click="doorLockRelatedSocket('set_admin_key', 'gateway')"
          >Set Admin Key Data</b-button
        >
      </div>
      <div class="col-md-4 mb-2">
        <b-button
          variant="primary"
          class="w-100"
          @click="doorLockRelatedSocket('set_date_time', 'gateway')"
          >Set Date-Time All Lock</b-button
        >
      </div>
    
      <div class="col-md-4 mb-2">
        <b-button
          variant="primary"
          class="w-100"
          @click="doorLockRelatedSocket('set_master_data', 'lock')"
          >Set Lock Master Data</b-button
        >
      </div>
     <div class="col-md-4 mb-2">
        <b-button
          variant="primary"
          class="w-100"
          @click="doorLockRelatedSocket('set_admin_key', 'lock')"
          >Set Lock Admin Data</b-button
        >
      </div>
      <div class="col-md-4 mb-2">
        <b-button
          variant="primary"
          class="w-100"
          @click="doorLockRelatedSocket('set_staff_key', 'lock')"
          >Set Lock Staff Data</b-button
        >
      </div> -->
